/** Main project script */
'use strict';


import {createApp} from 'vue';
import useCollapse from "./composables/collapser";
import CarouselHolder from './components/carousel-holder';
import SuggestiveSearch from './components/suggestive-search';
import MapBox from './components/map-box';
import MenuHandler from './components/menu-handler';
import TeamMembers from './components/team-members.vue';
import FeaturesCarousel from './components/features-carousel.vue';
import EventsCarousel from './components/events-carousel.vue';
import NewsAndCommunity from './components/news-and-community.vue';
import MembershipPanel from './components/membership-panel.vue';
import SimpleLightbox from "simplelightbox";


import 'vue3-carousel/dist/carousel.css'
import {Carousel, Navigation, Pagination, Slide} from 'vue3-carousel'


import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client/core';

var link = window.solout.baseUrl.split('/');
link.push('graphql');
link = link.filter(function (el) {
    if (el === null || el === undefined || el === "" || !el || el === " ") {
        return false;
    }
    return true;
});

link = '/' + link.join('/');

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: link,
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

import {createApolloProvider} from '@vue/apollo-option'

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})

//  end graphql
const toggleLightbox = (index) => {
    indexRef.value = index
    visibleRef.value = true
}

const app = createApp({
    components: {
        CarouselHolder,
        SuggestiveSearch,
        MapBox,
        MenuHandler,
        TeamMembers,
        FeaturesCarousel,
        EventsCarousel,
        NewsAndCommunity,
        MembershipPanel,
        Carousel,
        Slide,
        Pagination,
        Navigation
    },
    setup() {
        useCollapse();
    },
    // Shared app state
    data() {
        return {
            navigation: {
                open: false,
                openSubMenu: 0,
                mobileMenuOpen: false,
                mobileMenuSubMenu: 0,
                searchBarOpen: false
            },
            minPageHeight: null,
            scrolled: false,
            lightboxVisibleRef: false,
            lightboxIndexRef: 0,
            toggler: false,
            toggleEmbed: false
        };
    },
    computed: {
        showHeaderBg: function () {
            if (this.scrolled) {
                return true;
            }
            if (this.navigation.mobileMenuOpen) {
                return true;
            }
            return false;
        },
    },
    methods: {
        handleScroll: function () {
            // if the page is a EventPage, no header so always "scrolled"
            // detect by the presence of the banner or banner-carousel header

            var header_scroll_force = document.querySelector('.force-scrolled');

            if (!!header_scroll_force) {
                this.scrolled = true;
                return;
            }

            if (window.scrollY > 44) {
                // The screen is scrolled down more than 44 pixels from the top
                this.scrolled = true;
            } else {
                // The screen is at the top or close to it
                this.scrolled = false;
            }
        },
        fixSearchBar: function (action) {
            if (action === 'open') {
                this.navigation.searchBarOpen = true;
            } else {
                this.navigation.searchBarOpen = false;
            }
        },
        toggleSearchBar: function () {
            this.navigation.mobileMenuOpen = false;
            this.navigation.searchBarOpen = !this.navigation.searchBarOpen;
        },
        toggleSubmenu: function (id) {

            if (this.navigation.openSubMenu === id) {
                this.navigation.openSubMenu = 0;
            } else {
                this.navigation.openSubMenu = id;
            }
        },
        fixMobileMenu: function (action) {
            if (action === 'open') {
                this.navigation.mobileMenuOpen = true;
            } else {
                this.navigation.mobileMenuOpen = false;
            }
        },
        toggleMobileMenu: function (id) {
            this.navigation.mobileMenuOpen = !this.navigation.mobileMenuOpen;
        },
        toggleMobileSubmenu: function (id) {
            if (this.navigation.mobileMenuSubMenu === id) {
                this.navigation.mobileMenuSubMenu = 0;
            } else {
                this.navigation.mobileMenuSubMenu = id;
            }
        },
        toggleLightbox: function (index) {
            this.lightboxIndexRef = index;
            this.lightboxVisibleRef = true;
        },
        toggleTeamMemberLightbox: function (id) {
            // do something
        },
        goTo: function (url, newTab) {
            if (!url) {
                return false;
            }
            newTab = newTab || false;
            if (newTab) {
                return window.open(url);
            }
            return window.location.href = url;
        },
        setupScrollHelper: function () {
            let targets = document.querySelectorAll('[data-scrollhelper]');
            // loop through the targets
            const options = {
                root: null,
                threshold: 0.2
            };

            for (let i = 0; i < targets.length; i++) {
                let preset = targets[i].dataset?.presetClass?.trim().split(' ');
                let parent = targets[i].closest('section');
                parent.classList.add('animation-parent');
                if (preset) {
                    preset.forEach(value => targets[i].classList.add(value));
                    // targets[0].classList.add(preset.join[',']);
                }
            }

            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // process:
                        let me = entry.target;

                        let cssClass = me.dataset?.class?.trim().split(' ');

                        if (cssClass) {
                            cssClass.forEach(value => me.classList.add(value));
                            // me.classList.add(cssClass);
                        }

                        me.classList.add("appear-on-scroll");
                        observer.unobserve(me);
                    } else {
                        return;
                    }
                });
            }, options);

            targets.forEach(target => observer.observe(target));

        },
        toggleParentClass: function (parentSelector, className, method) {
            if (method === 'add') {
                document.querySelector(parentSelector).classList.add(className);
            } else {
                document.querySelector(parentSelector).classList.remove(className);
            }
        },
        setupLightboxes: function () {
            // let galleries = document.querySelectorAll('[data-gallery]');
            // galleries.forEach(gallery => {
            //     let galleryClass = '.' + gallery.dataset.gallery;
            //
            //     galleryClass += ' a';
            //     new SimpleLightbox(galleryClass, {
            //         widthRatio: 0.7,
            //         heightRatio: 0.7,
            //         uniqueImages: true
            //     });
            // })
            // Find all elements with data-gallery attribute
            const galleries = document.querySelectorAll('[data-gallery]');
            let container;
            // Loop through each gallery
            galleries.forEach((gallery, index) => {
                // Get gallery ID from the element or use the index
                const galleryId = gallery.getAttribute('data-gallery') || index;

                // Add a unique class if it doesn't already have one
                const galleryClass = `gallery-${galleryId}`;
                gallery.classList.add(galleryClass);

                // Initialize SimpleLightbox for this gallery
                this.registerOneLightbox(`.${galleryClass} a`);
            });
            container = document.querySelector('.lightbox-container');
            if (container) {
                container.addEventListener("click", this.handleCoverflowClick);
            }
        },
        handleCoverflowClick: function (event) {
            let linktarget;

            if (linktarget = event.target.closest('a[data-lightbox]')) {
                event.preventDefault();
                new SimpleLightbox(linktarget, {
                    widthRatio: 0.7,
                    heightRatio: 0.7,
                    uniqueImages: true
                }).open();
            }
        },
        registerOneLightbox: function (selector) {
            new SimpleLightbox(selector, {
                widthRatio: 0.7,
                heightRatio: 0.7,
                uniqueImages: true
            });
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll;
        // this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        // window.addEventListener('scroll', this.handleScroll);

    },
    mounted() {
        this.setupScrollHelper();
        this.handleScroll();
        this.setupLightboxes();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});

app.config.globalProperties.location = window.location;
app.use(apolloProvider);
app.mount('#tw_app');
